const styles = theme => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '8px',
    maxHeight: '70vh',
    minWidth: '776px',
    overflow: 'auto',
    '@media (min-width: 768px) and (min-height: 800px)': {
      minHeight: '620px',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    borderBottom: '1px solid #E5E7EB',
    '& h2': {
      margin: 0,
      fontSize: '18px',
      fontWeight: 600,
      color: '#111827',
      fontFamily: 'Inter',
    },
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    color: '#6B7280',
    cursor: 'pointer',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      color: '#374151',
    },
  },
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: '16px',
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    borderRight: '1px solid #E0E0E0',
    padding: '0px 24px 0px 0px',
  },
  mainContent: {
    flex: 1,
    padding: '0 0 0 20',
    overflow: 'auto',
  },
  leftSideListItem: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    padding: '8px',
    borderRadius: '8px',
    cursor: 'pointer',
    width: '200px',
    '&:hover': {
      backgroundColor: '#E3F3FF',
    },
    '& svg': {
      fontSize: '20px',
      color: '#6B7280',
    },
    '& p': {
      fontSize: '16px',
      color: '#374151',
      margin: 0,
    },
  },
  active: {
    backgroundColor: '#E3F3FF',
    '& svg': {
      color: '#111827',
    },
    '& p': {
      color: '#111827',
      fontWeight: 500,
    },
  },
})

export default styles
